// ==================== RESELLER LABELS ====================
// Display text shared by the admin Resellers screens and the reseller dashboard.

import type { Coupon, CouponDuration } from '../../services/resellers.service';

export const formatPercent = (value: number | string) => `${Number(value)}%`;

export const durationLabel = (duration: CouponDuration) =>
  duration === 'EVERY_PAYMENT' ? 'Every payment' : 'First payment only';

export const discountScopeLabel = (scope: Coupon['discountScope']) =>
  scope === 'PLAN_ONLY' ? 'Plan only' : 'Whole payment';

export const eligibilityLabel = (allowExistingCustomers: boolean) =>
  allowExistingCustomers ? 'New and existing customers' : 'New customers only';

// Compare the stored expiry instant, not the browser's calendar day. The server
// accepts new uses through the end of its chosen day, even in other timezones.
export const isCouponExpired = (coupon: Pick<Coupon, 'expiresAt'>) =>
  !!coupon.expiresAt && Date.parse(coupon.expiresAt) < Date.now();

/** The expiry is a server calendar day (YYYY-MM-DD): format it without a timezone shift */
export const formatExpiryDate = (value: string | null) => {
  if (!value) return 'No expiry';
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

/** Same wording as the customer's payment history */
export const paymentTypeLabel = (type: string) => {
  switch (type) {
    case 'SUBSCRIPTION':
      return 'New Subscription';
    case 'RENEWAL':
      return 'Renewal';
    case 'UPGRADE':
      return 'Plan Upgrade';
    case 'ADDON':
      return 'Lead Generation Add-on';
    case 'MANUAL':
      return 'Manual Payment';
    case 'ORGANIZATION':
      return 'Additional Accounts';
    case 'SETUP_FEE':
      return 'Setup Fee';
    default:
      return type;
  }
};
